import { pickBy } from 'lodash/fp';

export function prune<T extends Record<string, unknown>>(obj: T): Partial<T> {
  return pickBy((x) => {
    if (x == null) return false;
    if (Array.isArray(x) && x.length === 0) return false;
    // @ts-expect-error No need to complain about `object can be null`, when we check
    // for null above
    if (typeof x === 'object' && Object.keys(x).length === 0) return false;
    if (typeof x === 'string' && x === '') return false;

    return true;
  }, obj) as any;
}

export function deepPrune<T extends Record<string, unknown>, K extends keyof T>(
  obj: T,
  omittedKeys: K[] = [],
) {
  const finalObj: Record<string, unknown> = {};

  Object.keys(obj).forEach((key) => {
    if (omittedKeys.includes(key as K)) {
      finalObj[key] = obj[key];
    } else if (Array.isArray(obj[key])) {
      // @ts-ignore
      const array = obj[key].map((v) => deepPrune(v, omittedKeys));
      if (array.length !== 0) {
        finalObj[key] = array;
      }
    } else if (obj[key] && typeof obj[key] === 'object') {
      const nestedObj = deepPrune(
        obj[key] as Record<string, unknown>,
        omittedKeys as any,
      );
      if (Object.keys(nestedObj).length) {
        finalObj[key] = nestedObj;
      }
    } else if (obj[key] !== '' && obj[key] !== undefined && obj[key] !== null) {
      finalObj[key] = obj[key];
    }
  });
  return finalObj;
}
